import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { DoctorSocialService } from '../../doctor-social.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emit } from 'process';

@Component({
  selector: 'app-boost-post-dialog',
  templateUrl: './boost-post-dialog.component.html',
  styleUrls: ['./boost-post-dialog.component.css']
})
export class BoostPostDialogComponent implements OnInit {

  form: FormGroup;

  pageMode = 1

  constructor(
    public dialogRef: MatDialogRef<BoostPostDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    private toaster: ToastrService,
    public app: AppService
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      PostId: new FormControl('', Validators.required),
      Days: new FormControl('', Validators.required),
      Currency: new FormControl('JOD', Validators.required),
      PaymentType: new FormControl('2', Validators.required),
      UserCardId: new FormControl('', Validators.required),
      // typeH: new FormControl('', Validators.required),
    });
    this.postBoostInfo();
    this.getPostInsights();

    this.get("PostId").setValue(this?.data?.id)
  }

  get = (formControlName: string) => this.form.get(formControlName) as FormControl;

  boostInfo;
  postBoostInfo() {
    this.service.getBoostInfo().subscribe(
      res => {
        this.boostInfo = res.data
      }
    )
  }

  priceRes = null;
  onToggle(e) {
    this.priceRes = e * this?.boostInfo?.dailyPrice
  }

  radioBtns(e) {
    return
    if (e == 1) {
      this.get("Days").setValue(null)
      this.priceRes = null
    } else if (e == 2) {
      this.get("Days").setValue(this.boostInfo.minBoostDays)
      this.priceRes = this.boostInfo.dailyPrice
    }
  }


  insights;
  getPostInsights() {
    this.service.getInsights(this?.data?.id).subscribe(
      res => {
        this.insights = res.data
      }
    )
  }


  paymentCardSelected = new FormControl()
  // payment


  letRefresh: boolean = false
  addPayment() {
    this.letRefresh = true
    this.service.saveCardCheckOut().subscribe(
      res => {
        if (res.errorCode == 0) {
          const url = `https://www.ihospitalapp.com/IhospitalForm/payment_save.html?checkoutId=${res.data}`;
          window.open(url, '_blank');
        } else {
          this.toaster.error(res?.errorMessage);
        }
      }
    )
  }

  usedCards = null;
  next1() {
    this.pageMode = 2
    this.getMyCards();
  }

  getMyCards() {
    this.service.getMyCards().subscribe(
      res => {
        this.usedCards = res.data
        if (this.usedCards.length != 0) {
          let x = this.usedCards.find(x => x.isPrimary == true)
          this.paymentCardSelected.setValue(x.id)
        }
        this.letRefresh = false
      }
    )
  }
  // payment

  next2() {
    this.pageMode = 3
  }

  next3() {
    if (!this.paymentCardSelected.value || this.form.invalid) { return }
    let request = new FormData();
    request.append("PostId", this?.get("PostId")?.value);
    request.append("Days", this?.get("Days")?.value);
    request.append("Currency", "JOD");
    request.append("PaymentType", "2");
    request.append("UserCardId", this?.paymentCardSelected?.value);
    this.service.payBoostPostCheckOutId(request).subscribe(
      res => {
        if (res.errorCode == 0) {
          return (window.location.href = `https://www.ihospitalapp.com/IhospitalForm/payment_form_post.html?checkoutId=${res.data}`);
        } else {
          this.toaster.error(res?.errorMessage);
        }
      }
    )
  }

}
